import { formatAmountInput, parseAmountInput, moneyWords } from "@/lib/format";

// Shared "amount in words" caption. dark=true for the navy results panels.
export const MoneyWords = ({ value, suffix = "Rupees Only", dark = false, className = "", testId }) => {
  const text = moneyWords(value, suffix);
  if (!text) return null;
  return (
    <p data-testid={testId} className={`mt-1 text-[0.65rem] leading-snug ${dark ? "text-ivory/55" : "text-slate/70"} ${className}`}>
      {text}
    </p>
  );
};

// Money input with live en-IN comma formatting + amount-in-words caption.
// onChange receives a Number, or "" when the field is cleared (so users can
// delete freely); clamp on blur via the onBlur prop.
export const MoneyInput = ({ id, testId, wordsTestId, value, onChange, onBlur, max = 1e12, inputClass = "w-28 sm:w-32", wordsSuffix = "Rupees Only" }) => (
  <div>
    <div className="flex items-center rounded-xl border border-sand bg-cream px-3 py-1.5 focus-within:border-brass">
      <span className="mr-1 font-semibold text-concordia">₹</span>
      <input
        id={id}
        data-testid={testId}
        type="text"
        inputMode="numeric"
        value={value === "" ? "" : formatAmountInput(value)}
        onChange={(e) => {
          const raw = parseAmountInput(e.target.value);
          onChange(raw === "" ? "" : Math.min(max, Number(raw)));
        }}
        onBlur={onBlur}
        className={`bg-transparent text-right font-semibold text-concordia outline-none ${inputClass}`}
      />
    </div>
    <p data-testid={wordsTestId} className="mt-1 text-right text-[0.62rem] leading-snug text-slate/60">
      {value === "" ? "Amount in words will appear here." : moneyWords(value, wordsSuffix)}
    </p>
  </div>
);
